import { TripPartGenerationMode } from 'app/constants/configuration/tripPartGenerationMode'

export const getTripPartGenerationModeName = (
  tripPartGenerationMode: TripPartGenerationMode,
  translate: (string) => string,
  isNational: boolean = false,
): string => {
  const text: string = TripPartGenerationMode[tripPartGenerationMode]
  return translate(
    `${isNational ? 'national' : ''}tripPartGenerationMode.${text}`,
  )
}
